module.exports = __webpack_public_path__ + "img/ltkkids-1x.bba6204.jpg";